"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledSubFolderIconWrapper = exports.StyledIconWrapper = exports.StyledChip = exports.StyledLabelContainer = exports.StyledFolderElement = exports.StyledPlaceholder = exports.StyledSubFolderContainer = exports.StyledContainer = void 0;
const tslib_1 = require("tslib");
const styled_components_1 = tslib_1.__importStar(require("styled-components"));
const ui_common_components_1 = require("@desygner/ui-common-components");
exports.StyledContainer = styled_components_1.default.div `
  width: 100%;
  display: flex;
  flex-flow: column;
`;
exports.StyledSubFolderContainer = styled_components_1.default.div `
  display: flex;
  flex-flow: column;
  margin-left: ${({ theme, isRoot }) => isRoot ? 0 : ui_common_components_1.utils.rem(theme.Spacing.Size.Medium)};

  .restriction-subfolder {
    margin-left: ${({ theme }) => ui_common_components_1.utils.rem(20)};
  }

  ${({ isOpened }) => isOpened
    ? (0, styled_components_1.css) `
          height: auto;
          overflow: visible;
          opacity: 1;
        `
    : (0, styled_components_1.css) `
          overflow: hidden;
          height: 0;
          opacity: 0;
          padding: 0;
        `}
`;
exports.StyledPlaceholder = styled_components_1.default.div `
  margin-left: ${({ theme }) => ui_common_components_1.utils.rem(theme.Spacing.Size.MediumSmall)};
`;
exports.StyledFolderElement = styled_components_1.default.div `
  position: relative;
  display: flex;
  flex-flow: row;
  gap: ${({ theme }) => ui_common_components_1.utils.rem(theme.Spacing.Size.Small)};
  border-radius: ${({ theme }) => ui_common_components_1.utils.rem(theme.Spacing.Size.XXSmall)};
  padding: ${({ theme }) => ui_common_components_1.utils.rem(theme.Spacing.Size.XXSmall)};
`;
exports.StyledLabelContainer = styled_components_1.default.div `
  display: flex;
  width: 100%;
  height: ${({ theme }) => `${ui_common_components_1.utils.rem(theme.Form.InputSize.Medium.height)}`};
  border: 1px solid ${({ theme }) => theme.Color.Neutrals.Border};
  border-radius: ${({ theme }) => ui_common_components_1.utils.rem(theme.Border.Radius.Medium)};
  background: ${({ theme }) => theme.Color.Neutrals.Paper};
  padding: ${({ theme }) => `${ui_common_components_1.utils.rem(theme.Spacing.Size.XSmall)}`};
  user-select: none;
  word-wrap: break-word;
  white-space: nowrap;
  gap: ${({ theme }) => ui_common_components_1.utils.rem(theme.Spacing.Size.XXSmall)};
  &:hover {
    cursor: pointer;
  }
`;
exports.StyledChip = styled_components_1.default.div `
  background-color: ${({ theme }) => theme.Color.Brand.Lightest};
  border-radius: ${({ theme }) => ui_common_components_1.utils.rem(theme.Border.Radius.XSmall)};
  padding: ${({ theme }) => `${ui_common_components_1.utils.rem(theme.Spacing.Size.XXSmall)} ${ui_common_components_1.utils.rem(theme.Spacing.Size.XSmall)}`};
`;
exports.StyledIconWrapper = styled_components_1.default.div `
  display: flex;
  align-items: center;
  margin-left: auto;
`;
exports.StyledSubFolderIconWrapper = styled_components_1.default.div `
  display: flex;
  align-items: center;
  cursor: pointer;
`;
//# sourceMappingURL=FolderRestriction.style.js.map